import { render, staticRenderFns } from "./Settings-user.vue?vue&type=template&id=2b61b4ae&scoped=true&"
import script from "./Settings-user.vue?vue&type=script&lang=js&"
export * from "./Settings-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b61b4ae",
  null
  
)

export default component.exports